import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { bootstrapAuth } from '@/hooks/use-auth';
import '@/styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found.');
}

// Restore any persisted session before the first render decides on redirects.
void bootstrapAuth();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
